import {
  track,
  createScreenViewedEvent,
  createComponentClickedEvent,
} from "./base"

export const accountIndexViewed = () => {
  track(
    createScreenViewedEvent({
      current_screen: "Account",
    })
  )
}

export const accountEditPersonalInfoViewed = () => {
  track(
    createScreenViewedEvent({
      current_screen: "Account Edit Personal Info",
      from_screen: "Account",
    })
  )
}

export const accountEditEmailViewed = () => {
  track(
    createScreenViewedEvent({
      current_screen: "Account Edit Email",
      from_screen: "Account Edit Personal Info",
    })
  )
}
export const accountEditNameViewed = () => {
  track(
    createScreenViewedEvent({
      current_screen: "Account Edit Name",
      from_screen: "Account Edit Personal Info",
    })
  )
}

export const accountEditPhoneNumberViewed = () => {
  track(
    createScreenViewedEvent({
      current_screen: "Account Edit Phone Number",
      from_screen: "Account Edit Personal Info",
    })
  )
}

export const accountEditNotificicationsViewed = () => {
  track(
    createScreenViewedEvent({
      current_screen: "Account Edit Notifications",
      from_screen: "Account",
    })
  )
}

export const notificationsToggleClicked = ({
  actionTaken,
}: {
  actionTaken: "enable" | "disable"
}) => {
  track(
    createComponentClickedEvent({
      current_screen: "Account Edit Notifications",
      component_type: "toggle",
      component_function: "toggle notifications",
      action_taken: actionTaken,
    })
  )
}

export const notificationsEnabled = () => {
  track(["Notifications Enabled", {}])
}

export const notificationsDisabled = () => {
  track(["Notifications Disabled", {}])
}

